// The toast package wraps `content` in its own themed card (padding: 20px, border: 2px,
// border-radius: 16px) whose colors follow the app's current theme. The Figma design wants
// a fixed dark card regardless of theme, so this overlays the wrapper's box entirely:
// -22px cancels its 20px padding + 2px border, letting our own background/border/radius
// repaint the full card on top of it.
.Zai-toast {
  position: relative;
  display: flex;
  align-items: center;
  gap: 20px;
  width: 432px;
  margin: -22px;
  padding: 20px;
  background-color: #2b2b2b;
  border: 2px solid #d0b2ff;
  border-radius: 16px;
  cursor: pointer;

  .Zai-toast-message {
    flex: 1;
    min-width: 0;
    text-align: left;
    color: white;
  }

  .Zai-toast-title {
    display: inline-block;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: bottom;
  }

  .Zai-toast-close {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 20px;
    height: 20px;
    padding: 0;
    background: none;
    border: none;
    cursor: pointer;
    color: #d0b2ff;
  }
}

// Hides the toast package's own default close "×" button (always rendered as a sibling
// after `content`), since this toast supplies its own close icon matching the Figma design.
.Zai-toast ~ button {
  display: none;
}
